<template>
  <div class="box">
    <img src="/assets/image/clock_minute.png" class="minute" :style="minuteStyle" />
    <img class="hour" src="/assets/image/clock_hour.png" :style="hourStyle" />
    <ion-img class="face" src="/assets/image/clock_face.png"></ion-img>
  </div>
</template>

<script>
import {IonImg} from "@ionic/vue";
import {createGesture} from "@ionic/vue";
import common from "../../common";

export default {
  name: "TestClock",
  components: {
    IonImg
  },
  props: {
    record_initial_time: {type: Number, default: 0},
  },
  data() {
    return {
      initMinuteX: 0,
      initMinuteY: 0,
      initMinuteAngle: 0,
      hourStyle: {
        '-webkit-transform': 'rotate(0deg)'
      },
      minuteStyle: {
          '-webkit-transform': 'rotate(0deg)'
      },
      seq: 1,
      start_x: 0,
      start_y: 0,
      start_time: 0,
      last_angle: 0,
      isDragging: false,
    }
  },
  mounted() {
    const faceEl = document.querySelector('.face');
    
    createGesture({
      el: faceEl,
      direction: 'x',
      disableScroll: true,
      gestureName: 'move-x',
      gesturePriority: 1,
      onStart: (detail) => {
        this.onStart(detail);
      },
      onEnd: () => {
        this.onEnd();
      },
      onMove: (detail => {
        this.onMove(detail)
      })
    }).enable()
    createGesture({
      el: faceEl,
      direction: 'y',
      disableScroll: true,
      gestureName: 'move-y',
      gesturePriority: 0,
      onStart: (detail) => {
        this.onStart(detail);
      },
      onEnd: () => {
        this.onEnd();
      },
      onMove: (detail => {
        this.onMove(detail)
      })
    }).enable()

    // 添加鼠标事件支持
    faceEl.addEventListener('mousedown', this.onMouseDown);
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup', this.onMouseUp);
  },
  beforeUnmount() {
    const faceEl = document.querySelector('.face');
    if (faceEl) {
      faceEl.removeEventListener('mousedown', this.onMouseDown);
    }
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
    this.$emit('clock-drag-end');
  },
  methods: {
    onMouseDown: function (e) {
      e.preventDefault(); // 阻止图片拖动
      this.isDragging = true;
      this.onStart(e);
    },
    onMouseMove: function (e) {
      if (!this.isDragging) return;

      this.onMove({
        startX: this.start_x,
        startY: this.start_y,
        currentX: e.clientX,
        currentY: e.clientY
      });
    },
    onMouseUp: function () {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.onEnd();
    },
    onStart: function (detail) {
      this.$emit('clock-drag-start');
      this.initMinuteX = this.initMinuteY = 0;
      const point = this.getPoint(detail);
      this.start_x = point.x;
      this.start_y = point.y;
      this.start_time = common.getTestRecordTime(this.record_initial_time);
    },
    onEnd: function () {
      this.$emit('clock-drag-end');
      this.getAnswer(this.initMinuteAngle);

      this.$emit('addActionSequence', {
        seq: this.seq++,
        x: Math.round(this.start_x) * window.devicePixelRatio,
        y: Math.round(this.start_y) * window.devicePixelRatio,
        start_time: this.start_time,
        end_time: common.getTestRecordTime(this.record_initial_time),
        degree: (this.initMinuteAngle - this.last_angle).toFixed(1),
      })
      this.last_angle = this.initMinuteAngle;
    },
    onMove: function (detail) {
      this.$emit('moveClock')
      const element = document.getElementsByClassName('face')[0];
      const rect = element.getBoundingClientRect();
      const centreX = rect.left + rect.width / 2;
      const centreY = rect.top + rect.height / 2;
      const currentPoint = this.getPoint(detail);

      let initX = 0;
      let initY = 0;
      if (this.initMinuteX !== 0) {
        initX = this.initMinuteX;
        initY = this.initMinuteY;
      } else {
        initX = this.start_x;
        initY = this.start_y;
      }

      const x1 = initX - centreX;
      const y1 = initY - centreY;

      const x2 = currentPoint.x - centreX;
      const y2 = currentPoint.y - centreY;
      const angle1 = Math.atan2(y1, x1);
      const angle2 = Math.atan2(y2, x2);
      let angle = (angle2 - angle1) * 180 / Math.PI;

      if (angle > 180) {
        angle -= 360;
      } else if (angle < -180) {
        angle += 360;
      }

      this.initMinuteAngle += angle;

      this.hourStyle["-webkit-transform"] = 'rotate(' + this.initMinuteAngle * (30 / 360) + 'deg)'
      this.minuteStyle["-webkit-transform"] = 'rotate('+this.initMinuteAngle+'deg)'

      this.initMinuteX = currentPoint.x;
      this.initMinuteY = currentPoint.y;
    },
    getPoint: function (detail) {
      const source = detail && detail.touches ? detail.touches[0] : detail;

      if (!source) {
        return {x: 0, y: 0};
      }

      if (source.event && source.event.clientX !== undefined) {
        return {
          x: source.event.clientX,
          y: source.event.clientY,
        };
      }

      return {
        x: source.currentX !== undefined ? source.currentX : source.clientX || 0,
        y: source.currentY !== undefined ? source.currentY : source.clientY || 0,
      };
    },
    getAnswer: function (value) {
      this.$emit('getAnswer', Math.round(value));
    }
  }
}
</script>

<style scoped>
  .box{
    position: relative;
    left: 50%;
    width: 38vh;
    height: 38vh;
    margin-left: -19vh;
    margin-top: 2vh;
  }
  .face{
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: grab;
    user-select: none;
    -webkit-user-drag: none;
    touch-action: none;
  }
  .face:active{
    cursor: grabbing;
  }
  .hour{
    position: absolute;
    height: 9vh;
    width: 1vh;
    left: 50%;
    top: 50%;
    margin-left: -0.5vh;
    margin-top: -9vh;
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom;
    /*-webkit-transform:rotate(290deg);*/
  }
  .minute{
    position: absolute;
    height: 12vh;
    width: 1vh;
    left: 50%;
    top: 50%;
    margin-left: -0.5vh;
    margin-top: -12vh;
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom;
    /*-webkit-transform:rotate(500deg);*/
  }
</style>
